<template>
	<div class="py-10">
		<breadcrumb :items="breadcrumbs"></breadcrumb>
		<v-container fluid>
			<v-form v-on:submit.prevent="registerFarm" ref="form" v-model="valid" lazy-validation>
				<div class="page-title">
					<div class="text-h5 font-weight-black">{{ $t('farm.farmRegistration') }}</div>
					<v-spacer></v-spacer>
					<template>
						<div class="mt-5 text-center data-drop">
							<v-menu bottom origin="center center" transition="scale-transition">
								<template v-slot:activator="{ on, attrs }">
									<v-btn @click="$router.push({ name: 'My farm' })" v-bind="attrs" v-on="on" outlined color="primary"
										dark depressed>
										{{ $t('farm.cancel') }}
									</v-btn>
									<v-btn color="primary" dark v-bind="attrs" v-on="on" type="submit" depressed>
										{{ $t('farm.save') }}
									</v-btn>
								</template>
							</v-menu>
						</div>
					</template>
				</div>
				<div class="mt-2 form-section">
					<v-card class="mb-2" flat>
						<v-container fluid>
							<div class="font-weight-bold">{{ $t('farm.farmInformation') }}</div>
							<template>
								<v-row class="mt-2">
									<v-col cols="12" sm="6" md="3">
										<label for="text"> {{ $t('farm.farmName') }}<span>*</span></label>
										<v-text-field v-model="farm.farmName" :placeholder="$t('farm.farmName')" outlined dense required
											:error-messages="errors.name" :rules="farmRules.farmName"></v-text-field>
									</v-col>

									<!-- <v-col cols="12" sm="6" md="3">
                  							<label for="text">{{$t('farm.farmType')}}<span>*</span></label>
											<v-select
												v-model="farm.farmType"
												:items="farmTypes"
												item-text="name"
												item-value="id"
												:placeholder="$t('farm.farmType')"
												outlined
												dense
												class="text-capitalize"
												:error-messages="errors.farmType"
												:rules="farmRules.farmType"
											></v-select>
                						</v-col> -->

									<v-col cols="12" sm="6" md="3">
										<label for="text">{{ $t('farm.farmOwner') }} <span>*</span> </label>
										<v-text-field v-model="farm.farmOwner" outlined dense item-text="farmOwner" item-value="id"
											:placeholder="$t('farm.farmOwner')" :error-messages="errors.farmOwner"
											:rules="farmRules.farmOwner"></v-text-field>
									</v-col>

									<v-col cols="12" sm="6" md="3">
										<label for="text">{{ $t('farm.ownershipType') }} </label>
										<v-select :items="ownershipTypes" item-text="name" item-value="id"
											:placeholder="$t('farm.ownershipType')" outlined dense v-model="farm.farmOwnershipType"
											class="text-capitalize"></v-select>
									</v-col>

									<v-col cols="12" sm="6" md="3" v-show="farm.farmOwnershipType == 'community'">
										<label for="text">{{ $t('farm.CommunityName') }}</label>
										<v-text-field item-text="name" item-value="id" :placeholder="$t('farm.CommunityName')" outlined
											dense v-model="farm.communityName" class="text-capitalize"></v-text-field>
									</v-col>

									<v-col cols="12" sm="6" md="3" v-show="farm.farmOwnershipType != 'community'">

									</v-col>

									<v-col cols="12" sm="6" md="3">
										<label>{{ $t('farm.govRegistrationNo') }}</label>
										<v-text-field :placeholder="$t('farm.govRegistrationNo')" outlined dense
											v-model="farm.govRegistrationNum"></v-text-field>
									</v-col>

									<!-- <v-col cols="12" sm="6" md="3">
											<label>{{$t('farm.contractMating')}}<span>*</span></label>
											<v-text-field
												:placeholder="$t('farm.contractMating')"
												outlined
												dense
												v-model="farm.contractMating"
												:error-messages="errors.contractMating"
												:rules="farmRules.contractMating"
											></v-text-field>
										</v-col> -->

									<v-col cols="12" sm="6" md="3">
										<label>{{ $t('farm.productionSystem') }}
											<v-tooltip right color="black" max-width="320">
												<template v-slot:activator="{ on, attrs }">
													<v-icon v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
												</template>
												<span>Types of farming system should be chosen depending upon the geographical and local
													climatic conditions with keeping economics in mind. E.g. Loose Farming, Conventional barn
													system and free range system.</span>
											</v-tooltip>
										</label>
										<v-select :items="farmProductionSystems" :placeholder="$t('farm.productionSystem')" outlined dense
											class="text-capitalize" item-text="name" item-value="id" v-model="farm.productionSystem" multiple>
										</v-select>
									</v-col>

									<v-col cols="12" sm="6" md="3">
										<label>{{ $t('farm.cooperativeID') }}
											<v-tooltip right color="black" max-width="320">
												<template v-slot:activator="{ on, attrs }">
													<v-icon v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
												</template>
												<span>{{ $t("farm.thisFieldApplyHelpText") }}</span>
											</v-tooltip>
										</label>
										<v-text-field :placeholder="$t('farm.cooperativeID')" outlined dense v-model="farm.cooperativeId">
										</v-text-field>
									</v-col>
									<v-col cols="12" sm="6" md="3">
										<label>{{ $t('farm.cooperativeName') }} </label>
										<v-text-field :placeholder="$t('farm.cooperativeName')" outlined dense
											v-model="farm.cooperativeName"></v-text-field>
									</v-col>
								</v-row>
							</template>
						</v-container>
					</v-card>
					<v-card class="mt-5 mb-5" flat>
						<v-container fluid>
							<div class="font-weight-bold">{{ $t('farm.farmLicenseInformation') }}</div>
							<template>
								<v-row class="mt-2">
									<v-col cols="12" sm="6" md="3">
										<label>{{ $t('farm.licenseNumber') }}</label>
										<v-text-field :placeholder="$t('farm.licenseNumber')" outlined v-model="farm.licenceNum" dense>
										</v-text-field>
									</v-col>

									<v-col cols="12" sm="6" md="3">
										<label>{{ $t('farm.licenseExpiryDate') }} </label>
										<v-menu ref="menu" v-model="menu" :close-on-content-click="false" dense
											transition="scale-transition" offset-y min-width="auto">
											<template v-slot:activator="{ on, attrs }">
												<v-text-field v-model="farm.licenceExpiryDate" placeholder="Choose the date"
													append-icon="mdi-calendar" outlined readonly dense v-bind="attrs" v-on="on"
													v-on:click:append="menu = true" :error-messages="errors.licenceED" :rules="farmRules.licenceED">
												</v-text-field>
											</template>
											<v-date-picker v-model="farm.licenceExpiryDate" no-title scrollabel
												:min="new Date().toISOString().substr(0, 10)">
												<v-spacer></v-spacer>
												<v-btn text color="primary" @click="menu = false">
													{{ $t('farm.cancel') }}
												</v-btn>
												<v-btn text color="primary" @click="$refs.menu.save(farm.licenceExpiryDate)">
													{{ $t('farm.ok') }}
												</v-btn>
											</v-date-picker>
										</v-menu>
									</v-col>

									<v-col cols="12" sm="6" md="3">
										<label>{{ $t('farm.regulatorName') }}
											<v-tooltip right color="black" max-width="320">
												<template v-slot:activator="{ on, attrs }">
													<v-icon v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
												</template>
												<span>Name of regulator which released the license.</span>
											</v-tooltip>
										</label>
										<v-text-field :placeholder="$t('farm.regulatorName')" outlined dense v-model="farm.regulatorName">
										</v-text-field>
									</v-col>

									<v-col cols="12" sm="6" md="3">
										<label>{{ $t('farm.regulatorRepresentativeName') }}</label>
										<v-text-field :placeholder="$t('farm.regulatorRepresentativeName')" outlined dense
											v-model="farm.regulatorRepresentiveName"></v-text-field>
									</v-col>
								</v-row>
							</template>
						</v-container>
					</v-card>

					<v-card class="mt-5" flat id="geofenceSection">
						<v-container>
						<!-- <v-alert :outlined="geofenceValidation" :color="geofenceValidation ? 'red' : ''" fluid class="pb-10"> -->
							<div class="font-weight-bold mb-7">{{ $t('farm.farmLocationSize') }}</div>
							<template>
							
								<v-row class="mt-5" >
									<v-col cols="12" sm="6" md="3">
										<label>{{ $t('farm.farmStateInfo') }}<span>*</span></label>
										<v-text-field ref="farmLocationTextField" :rules="farmRules.address" readonly @click="showFarmLocation=true" id="dialog-link1" placeholder="Please click to choose location" outlined dense v-model="farm.address">
										</v-text-field>	
									</v-col>
									<v-col cols="12" sm="6" md="3">
										<label>{{ $t('farm.country') }} </label>
										<v-autocomplete placeholder="Country" outlined :items="countries" item-value="Name"
											class="phone-drop rounded-r-0 outline-l-0" v-model="farm.country" :filter="filterCountry" dense
											ref="phoneSelect" >
											<template v-slot:item="slotProps">
												<i :class="['mr-2', 'em', `em-flag-${slotProps.item.Code.toLowerCase()}`]"></i>
												{{ `${slotProps.item.Name}` }}
											</template>
											<template slot="selection" slot-scope="data">
												<span class="text-truncate">{{ `${data.item.Name}` }}</span>
											</template>
										</v-autocomplete>
									</v-col>

									<v-col cols="12" sm="6" md="3">
										<label>{{ $t('farm.stateProvince') }} <span>*</span></label>
										<v-text-field :error-messages="errors.name" :rules="farmRules.state" :placeholder="$t('farm.stateProvince')" outlined dense v-model="farm.state"
											></v-text-field>
									</v-col>

									<v-col cols="12" sm="6" md="3">
										<label>{{ $t('farm.city') }} </label>
										<v-text-field :placeholder="$t('farm.city')" outlined dense v-model="farm.city"></v-text-field>
									</v-col>

									<v-col cols="12" sm="6" md="3">
										<label>{{ $t('farm.postal') }} </label>
										<v-text-field :placeholder="$t('farm.postal')" outlined dense v-model="farm.street"></v-text-field>
									</v-col>


									<v-col cols="12" sm="6" md="3">
										<label>{{ $t('farm.farmNumber') }}
											<v-tooltip right color="black" max-width="320">
												<template v-slot:activator="{ on, attrs }">
													<v-icon v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
												</template>
												<span>The postal Number of farm similar to House number.</span>
											</v-tooltip>
										</label>
										<v-text-field :placeholder="$t('farm.farmNumber')" outlined dense v-model="farm.farmNumber"
											></v-text-field>
									</v-col>


									<v-col cols="12" sm="6" md="3">
										<label>{{ $t('farm.totalFarmSize') }} </label>
										<v-row no-gutters class="d-flex">
											<v-col cols="6" class="pr-1">
												<v-text-field v-model="farm.area" :placeholder="$t('farm.totalFarmSize')" outlined dense
													></v-text-field>
											</v-col>
											<v-col cols="6">
												<v-select :items="farmUnits" v-model="farm.areaUomId" placeholder="Select Unit" outlined
													class="text-capitalize" item-text="name" item-value="id" dense @change="changeAreaUnit">
												</v-select>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
								<v-row class="px-2">
									<v-col sm="6" md="6">
										<v-btn color="primary" dark depressed outlined @click="showGeofenceTool">
											{{ $t('farm.useGeofenceTool') }}
										</v-btn>
										<!-- <p class="mt-2 red--text" v-if="farmGeofence?.length === 0">
											Note: Geofence is required for Satellite Reports and to add zones.
										</p> -->
									</v-col>
								</v-row>
							</template>

						<!-- </v-alert> -->
					</v-container>	
					</v-card>
				</div>

			</v-form>
		</v-container>
		<v-dialog v-model="geofencingStepper">

			<v-layout justify-center>
				<v-stepper :max-width="1050" v-model="stepperIndex">

							<v-stepper-items>
							<v-stepper-content step="1">

								<v-toolbar color="secondary rounded" flat> 
									<v-toolbar-title class="white--text ">Video Tutorial</v-toolbar-title>

								</v-toolbar>
								<!-- <v-layout class="justify-center" > <span style="color: #57b357">Video Tutorial</span> </v-layout> -->
						

								Click on the map to start geofencing

								<div class="text-center">
									<video autoplay loop muted width="700" controls>
									<source src="/img/geofencing.mp4" type="video/mp4">
								</video>
									</div>

							
								<v-btn @click="geofencingStepper = false" text>
								Prev
								</v-btn>

								<v-btn
								color="primary"
								@click="stepperIndex = 2"
								>
								Next
								</v-btn>

								
							</v-stepper-content>
					
							<v-stepper-content step="2" style="max-width: 700px;">
								<v-toolbar color="secondary rounded" flat> 
									<v-toolbar-title class="white--text ">Video Tutorial</v-toolbar-title>

								</v-toolbar>
								

								You can also drag the vertex, or delete them using the delete button on the right side. Geofence can also be cleared using the clear button
								<br>
								<div class="text-center">
									<video autoplay loop muted width="700" controls>
									<source src="/img/delete_geo.mp4" type="video/mp4">
								</video>
								</div>
								
								<v-checkbox v-model="dontShowAgain" label="Dont show this tutorial again"></v-checkbox>
								<v-btn @click="stepperIndex = 1" text>
								Prev
								</v-btn>
								<v-btn
								color="primary"
								@click="geofencingStepper = false; dontShowMethod()"
								>
								Next
								</v-btn>

							
							</v-stepper-content>

							</v-stepper-items>
				</v-stepper>
				</v-layout>
			
		</v-dialog>
		<prompt-dialog
			@closeDialog="showPromptDialog = false"
			@saveData="saveFormData"
			:dialogI="showPromptDialog"
			v-if="showPromptDialog"
			/>
		<primary-geofence v-if="showMap" :showMap="showMap" :farm="farm" @close-location-modal="locationMapClosed"
			@close-without-change="closeWithoutChange"></primary-geofence>

		<FarmLocation v-if="showFarmLocation" :showMap="showFarmLocation" :farm="farm" @close-location-modal="farmLocationClosed"
			@close-without-change="closeWithoutChange"/>
			</div>
</template>

<script>

import loadingMixin from "@/mixins/LoadingMixin";
import FarmService from "@/_services/farmService";
import Breadcrumb from "@/components/core/Breadcrumb";
import { farmRules } from "@/validations/FarmFormRules.js";
import countries from "@/constants/countries.js"
import generalMixin from "@/mixins/GeneralMixin";
import PrimaryGeofence from "./PrimaryGeofence.vue"
import FarmLocation from "./FarmLocation.vue"
import gql from 'graphql-tag';
import { users } from '@/graphql/Users.gql';
import PromptDialog from "../common/PromptDialog.vue";

export default {
	apollo: {

		users: {
			query: users,
			update: data => {
				console.log(data, 'data')
				return data.users
			},
		}
	},
	computed: {
		farmers() {
			return this.users.map(u => {
				u.fullName = `${u.firstName} ${u.lastName}`
				return u
			})
		},
		hasChanged() {
      return true;
    }
	},
	watch: {
		// 'farm.farmOwnershipType': function (nV) {
		// 	if (nV != 'community') {
		// 		this.farm.communityName = ''
		// 	}

		// }
	},
	async mounted() {
		const options = await FarmService.getFarmOptions();
		this.farmTypes = options.FarmTypes;
		// this.ownershipTypes = options['farm-ownership-type'];
		this.farmProductionSystems = options.FarmProductionSystem;
	},
	components: {
		'breadcrumb': Breadcrumb,
		PrimaryGeofence,
		"prompt-dialog": PromptDialog,
		FarmLocation
	},
	data() {
		return {
			dontShowAgain: false,
			geofencingStepper: false,
			stepperIndex: 1,
			showFarmLocation: false,
			geofenceValidation: false,
			addManually: false,
			users: [],
			countries,
			farmProductionSystems: [],
			farmTypes: [],
			ownershipTypes: [
				{ id: 'personal', name: 'Personal' },
				{ id: 'community', name: 'Community' },
				{ id: 'corporate', name: 'Corporate' }
			],
			showMap: false,
			menu: "",
			error: false,
			countryLoading: false,
			stateLoading: false,
			cityLoading: false,
			errors: {
				name: "",
				farmType: "",
				farmownershipType: "",
				ownerName: "",
				govRegistrationNo: "",
				contractMating: "",
				productionSystemOptId: "",
				regulatorRepName: "",
				cooperativeID: "",
				licenceNumber: "",
				licenceED: "",
				regulatorName: "",
				lat: "",
				log: ""
			},
			breadcrumbs: [
				{
					text: this.$t('dashboard'),
					disabled: false,
					to: "/"
				},
				{
					text: this.$t('farm.farms'),
					link: true,
					exact: true,
					disabled: false,
					to: { name: "My farm" }
				},
				{
					text: this.$t('farm.registerAfarm'),
					disabled: true,
				},
			],
			farm: {
				farmNumber: "",
				farmName: "",
				registrationNo: "",
				lat: 0,
				log: 0,
				address: "",
				area: "",
				areaUomId: 1,
				parameter: 0,
				parameterUomId: 1,
				farmOwnershipType: "personal",
				farmGeofence: [],
				farmType: null,
				productionSystem: null,
				farmOwner: null,
				country: "",
				state: "",
				city: "",
				govRegistrationNum: "",
				contractMating: "",
				cooperativeId: "",
				licenceNum: "",
				licenceExpiryDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
				regulatorName: "",
				houseNum: "",
				street: "",
				regulatorRepresentiveName: "",
				communityName: ""
			},
			// countryId: 101,
			// stateId: 4022,
			// farmType: [],
			// farmownershipType: [],
			// productionSystem: [],
			// res: [],
			farmUnits: [{ id: 1, name: "Acre" }, { id: 2, name: "Hectare" }],
			periUni: [{ id: 2, name: "hectare" }],
			farmRules,
			valid: true,
			// country: [],
			// state: [],
			// city: [],
			// users:[],
			showPromptDialog: false,
			promptToRoute: null,
			promptNextRoute: false,
		};
	},
	methods: {
		/* eslint-disable */
		dontShowMethod() {
			localStorage.setItem('dontShowAgain', 1);
		},
		showGeofenceTool() {
			if(this.farm.address !== ""){
				if(!parseInt(localStorage.getItem('dontShowAgain'))) {	
					this.geofencingStepper = true
					this.stepperIndex = 1
				}
				this.showMap = true
			}else{
				console.log(this.$refs.farmLocationTextField.focus(), 'farmLocationTextField')
				this.$notify({
					text: 'Farm Location is required.',
					type: 'error'
				})
			}

		},
		farmLocationClosed(data) {
			console.log('sss', data);
			this.showFarmLocation = false;
			this.farm.lat = data.lat;
			this.farm.log = data.log;
			this.farm.address = data.address;
			this.farm.country = data.addressData.country
			this.farm.city = data.addressData.locality
			this.farm.state = data.addressData.administrative_area_level_1
			this.farm.street = data.addressData.postal_code
		},
		changeAreaUnit() {

			if (this.farm.areaUomId === 1) {
				this.farm.area = parseFloat(this.farm.area * 2.47105).toFixed(5)
			} else {
				this.farm.area = parseFloat(this.farm.area / 2.47105).toFixed(5)
			}
		},
		locationMapClosed(gdata) {
			this.geofenceValidation = false
			this.addManually = true
			this.showMap = false;
			this.farm.lat = gdata.lat;
			this.farm.log = gdata.log;
			this.farm.address = gdata.address;
			this.farm.coordinates = gdata.farmGeofence;
			this.farm.farmGeofence = gdata.farmGeofence;
			this.farm.area = `${gdata.area}`
			this.farm.parameter = gdata.parameter
			this.farm.areaUomId = gdata.areaUomId
			this.farm.country = gdata.addressData.country
			this.farm.city = gdata.addressData.locality
			this.farm.state = gdata.addressData.administrative_area_level_1
			this.farm.street = gdata.addressData.postal_code

		},
		closeWithoutChange() {
			this.showMap = false
			this.showFarmLocation = false
			// this.geofenceValidation = true
		},
		loadOptions() {
			const options = {
				options: ["production-system", "farm-ownership-type", "farm-type"],
			};
			FarmService.loadoptions(options).then((data) => {
				let newdata = data.data["production-system"];
				this.productionSystem = newdata;
				let ownerdata = data.data["farm-ownership-type"];
				this.farmownershipType = ownerdata.map((item) => item.name);
				let farmdata = data.data["farm-type"];
				this.farmType = farmdata.map((item) => item.name);
			});
		},
		registerFarm() {
			this.showPromptDialog = false;
			this.promptNextRoute = true;
			// if (!this.farm.country) {
			// 	this.geofenceValidation = true
			// 	const element = document.getElementById("geofenceSection")
			// 	if (this.farm.farmName && this.farm.farmOwner) {
			// 		element.scrollIntoView({ behavior: "smooth" })
			// 	}
			// 	this.$notify({
			// 		title: "Add Farm Geofence data",
			// 		text: 'click USE GEOFENCE TOOL',
			// 		type: "error",
			// 	});
			// }
			if (!this.$refs.form.validate()) return;
			// if (this.farm.address == '' || !this.farm.farmGeofence || this.farm.farmGeofence.length < 1) {

			// 	this.$notify({
			// 		title: "Add Farm Geofence data",
			// 		text: 'click USE GEOFENCE TOOL',
			// 		type: "error",
			// 	});
			// 	return;
			// }
			delete this.farm.coordinates;
			this.startLoading()
			this.$apollo.mutate({
				mutation: gql`mutation createFarm($data: CreateFarmInput!) {
				createFarm(createFarmInput: $data) {
					id
				}
        	}`,
				variables: {
					data: this.farm
				}
			}).then(() => {
				this.stopLoading();
				this.$notify({
					title: `Farm added successfully`,
					text: "success",
					type: "success",
					position: "center",
				});
				this.$router.push({ name: 'My farm' })
			})
				.catch(e => {
					console.log(e);
					this.stopLoading();
					this.$notify({
						title: e?.message?.split("HttpException:")[1] || `Farm cannot be added.`,
						text: e?.message?.split("HttpException:")[1] || 'Something went wrong!',
						type: "error",
						position: "center",
						duration: 1000000
					});
				})
		},
		saveFormData(answer) {
      this.showPromptDialog = false;
      if (!answer) {
        this.promptNextRoute = true;
        this.$router.push(this.promptToRoute);
      }
    },
	},
	mixins: [loadingMixin, generalMixin],
	beforeRouteLeave(to, from, next) {
    if (this.promptNextRoute) {
      next();
    } else {
      if (this.hasChanged) {
        this.promptToRoute = to;
        this.showPromptDialog = true;
      } else {
        next();
      }
    }
  },
};
</script>

<style >
.page-title {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 0px 0px 15px;
}

.button {
	float: right;
}

.v-btn {
	margin-right: 5px;
}

.route {
	text-decoration: none !important;
}

.form-group {
	margin-top: -20px;
}

.form-section label {
	display: inline-block;
	margin-bottom: 0.5rem;
	/* color: #97A8B8; */
	font-size: 14px;
	font-family: Poppins-Medium;
	letter-spacing: 0.5px;
	white-space: nowrap;
}

.form-section label span {
	color: red;
}

.v-list-item__title {
	text-transform: capitalize;
}

#dialog-link1 {
	cursor: pointer !important;
}

#dialog-link1::placeholder {
  color: #002287 !important;
  text-decoration: underline !important;
}
</style>